export default {
	mounted(el) {
		const wrapper = el.closest('[data-prlx-mouse-wrapper]') ?? window;

		const cx = +(el.dataset.prlxCx ?? 20);
		const cy = +(el.dataset.prlxCy ?? 20);

		const dirX = el.hasAttribute('data-prlx-dxr') ? -1 : 1;
		const dirY = el.hasAttribute('data-prlx-dyr') ? -1 : 1;
		const speed = +(el.dataset.prlxA ?? 100);

		const disableX = cx === 0;
		const disableY = cy === 0;

		let posX = 0,
			posY = 0;
		let percX = 0,
			percY = 0;
		let rafId;

		// Функция анимации
		const animate = () => {
			posX += ((percX - posX) * speed) / 1000;
			posY += ((percY - posY) * speed) / 1000;

			const tX = disableX ? 0 : (dirX * posX) / (cx / 10);
			const tY = disableY ? 0 : (dirY * posY) / (cy / 10);

			el.style.transform = `translate3D(${tX}%, ${tY}%, 0)`;
			rafId = requestAnimationFrame(animate);
		};

		// Обработчик движения мыши — для десктопа
		const onMouseMove = (e) => {
			const w = window.innerWidth;
			const h = window.innerHeight;
			if (!disableX) percX = ((e.clientX - w / 2) / w) * 100;
			if (!disableY) percY = ((e.clientY - h / 2) / h) * 100;
		};

		// Обработчик скролла — для мобилки
		const onScroll = () => {
			const rect = el.getBoundingClientRect();
			const windowHeight = window.innerHeight;

			// Вычисляем процент прокрутки элемента внутри окна
			// от -el.offsetHeight (полностью выше окна) до windowHeight (полностью ниже окна)
			const scrollPercent =
				((windowHeight - rect.top) / (windowHeight + rect.height)) * 100;

			// Ограничиваем значения 0..100 для стабильности
			const clampedPercent = Math.min(Math.max(scrollPercent, 0), 100);

			// Используем clampedPercent для смещений
			if (!disableX) percX = (clampedPercent - 50) * 2; // смещаем от -100 до 100%
			if (!disableY) percY = (clampedPercent - 50) * 2;
		};

		// Проверяем мобильное устройство (простой метод)
		const isMobile = /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
			navigator.userAgent
		);

		if (isMobile) {
			window.addEventListener('scroll', onScroll);
			// Для инициализации сразу
			onScroll();
		} else {
			wrapper.addEventListener('mousemove', onMouseMove);
		}

		animate();

		el._parallaxDestroy = () => {
			if (isMobile) {
				window.removeEventListener('scroll', onScroll);
			} else {
				wrapper.removeEventListener('mousemove', onMouseMove);
			}
			cancelAnimationFrame(rafId);
		};
	},

	unmounted(el) {
		el._parallaxDestroy?.();
	},
};
